import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { modalConfig, ModalEnum } from 'src/app/core/util/modalConfig';
import { Globals } from 'src/app/globals';
import { IqSummaryModalComponent } from '../iq-summary-modal/iq-summary-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { IqGenerateAudioNotesModalComponent } from '../iq-generate-audio-notes-modal/iq-generate-audio-notes-modal.component';

@Component({
  selector: 'app-generic-iq-analysis',
  templateUrl: './generic-iq-analysis.component.html',
  styleUrls: ['./generic-iq-analysis.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GenericIqAnalysisComponent {
  showSummaryDropdown: boolean = false;
  @Input() type: string;
  @Input() stakeholder: any
  @Input() name: string;
  @Output() loadAllLogs: EventEmitter<any> = new EventEmitter();
  
  constructor(public globals: Globals, private elRef: ElementRef, private dialog: MatDialog){}

  toggleDropdown() {
    this.showSummaryDropdown = !this.showSummaryDropdown;
  }

  @HostListener('document:click', ['$event'])
  closeDropdown(event: MouseEvent){
    if (this.showSummaryDropdown && !this.elRef.nativeElement.contains(event.target)) {
      this.showSummaryDropdown = false;
    }
  }

  openSummaryModal(){
    this.showSummaryDropdown = false;
    if (this.type !== 'contactmoments') {    
      this.dialog.open(IqSummaryModalComponent, modalConfig({
        data:{ type: this.type, stakeholder: this.stakeholder,stk_name:this.name },
        panelClass: ['custom-dialog-container', 'purple-custom-shadow'],
        disableClose:true,
      }, ModalEnum.ModalMedium));
    } else {
      const dialog = this.dialog.open(IqGenerateAudioNotesModalComponent, modalConfig({
        data:{ type: this.type },
        panelClass: ['custom-dialog-container', 'purple-custom-shadow'],
        disableClose:true,
      }, ModalEnum.ModalMedium));

      dialog.afterClosed().subscribe((res) => {
        this.loadAllLogs.emit();
      })
    }
  }
}
